export const ctaData = [
  {
    title: 'Try Hetzner Cloud',
    text: 'Get €20/$20 free credit!',
    subtext: 'Valid until: 31 December 2025\nValid for: 3 months and only for new customers ',
    tag: 'cloud',
    url: 'https://www.hetzner.com/cloud?pk_campaign=community_cta&pk_source=community&pk_medium=cta&pk_content=cloud',
    buttonText: 'Get started',
    code: 'HCC25-L4ET82'
  },
  {
    preTitle: 'Discover our',
    title: 'Dedicated Servers',
    text: 'Configure your dream server. Top performance with an excellent connection at an unbeatable price!',
    tag: 'dedicated',
    url: 'https://www.hetzner.com/dedicated-rootserver?pk_campaign=community_cta&pk_source=community&pk_medium=cta&pk_content=dedicated',
    buttonText: 'Configure now'
  },
  {
    preTitle: 'Discover our',
    title: 'Managed Servers',
    text: 'Focus on your projects. We\'ll take care of the configuration and updates.',
    tag: 'managed',
    url: 'https://www.hetzner.com/managed-server?pk_campaign=community_cta&pk_source=community&pk_medium=cta&pk_content=managed',
    buttonText: 'Get started'
  },
  {
    preTitle: 'Discover our',
    title: 'Load Balancer',
    text: 'Distribute traffic between multiple targets and avoid having a single point of failure.',
    tag: 'loadbalancer',
    url: 'https://www.hetzner.com/cloud/load-balancer?pk_campaign=community_cta&pk_source=community&pk_medium=cta&pk_content=load-balancer',
    buttonText: 'Get started'
  },
  {
    preTitle: 'Discover our',
    title: 'Cloud Volumes',
    text: 'With our flexible scalable volumes, each cloud server can be expanded with additional SSD-based storage as needed.',
    tag: 'cloudvolumes',
    url: 'https://www.hetzner.com/cloud?pk_campaign=community_cta&pk_source=community&pk_medium=cta&pk_content=cloud-volumes',
    buttonText: 'Get started'
  },
  {
    preTitle: 'Discover our',
    title: 'Storage Share',
    text: 'Easily store and share files. Access your data at any time and from any place.',
    tag: 'storageshare',
    url: 'https://www.hetzner.com/storage/storage-share?pk_campaign=community_cta&pk_source=community&pk_medium=cta&pk_content=storage-share',
    buttonText: 'Get started'
  },
  {
    preTitle: 'Discover our',
    title: 'Storage Box',
    text: 'Access your storage from everywhere and at any time via PC, smartphone, and tablet.',
    tag: 'storagebox',
    url: 'https://www.hetzner.com/storage/storage-box?pk_campaign=community_cta&pk_source=community&pk_medium=cta&pk_content=storage-box',
    buttonText: 'Get started'
  },
  {
    preTitle: 'Discover',
    title: '#Hetzner4gamers',
    text: 'Take your gaming experience to the next level! Discover which Hetzner server is best for your gaming world.',
    tag: 'gaming',
    url: 'https://hetzner.com/4gamers?pk_campaign=community_cta&pk_source=community&pk_medium=cta&pk_content=4gamers',
    buttonText: 'Get started'
  },
  {
    preTitle: 'Discover our',
    title: 'GPU Server',
    text: 'Kickstart your AI project with our cost-efficient and powerful dedicated GPU servers.',
    tag: 'gpu',
    url: 'https://www.hetzner.com/dedicated-rootserver/matrix-gpu?pk_campaign=community_cta&pk_source=community&pk_medium=cta&pk_content=gpu',
    buttonText: 'Find out more'
  }
]
